import { PageWrapper } from '@innovyze/stylovyze';
import styled from 'styled-components';

export const em = (px: number, basePx = 16) => `${px / basePx}em`;
export const rem = (px: number, basePx = 16) => `${px / basePx}rem`;

// eslint-disable-next-line @typescript-eslint/naming-convention
export const FullPageWrapper = styled(PageWrapper)`
	display: flex;
	flex-direction: column;
	height: 100%;
	padding-bottom: 0px;
`;

// eslint-disable-next-line @typescript-eslint/naming-convention
export const FullPage = styled.div`
	height: 100%;
	overflow: auto;
`;
